"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*---------------------------------------------*/
var Component = /*#__PURE__*/function (_React$Component) {
  _inherits(Component, _React$Component);

  var _super = _createSuper(Component);

  function Component() {
    var _this;

    var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Component);

    _this = _super.call(this);
    _this.cfg = cfg;
    _this.id = Math.floor(Math.random() * 10000);
    _this.ref = /*#__PURE__*/_react.default.createRef();
    _this.classNames = [];
    _this.onBodyKeydown = _this.onBodyKeydown.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Component, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.cfg.keyboardFocusOnly && document.body.addEventListener("keydown", this.onBodyKeydown);
      var el = this.ref && this.ref.current;

      if (el) {
        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type === "attributes") {
              if (mutation.attributeName === "tabindex" && el.getAttribute("tabIndex") === "-1") {
                el.blur();
              }
            }
          });
        });
        observer.observe(el, {
          attributes: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cfg.keyboardFocusOnly && document.body.removeEventListener("keydown", this.onBodyKeydown);
    }
  }, {
    key: "onBodyKeydown",
    value: function onBodyKeydown(event) {
      var _this2 = this;

      if (event.key === "Tab") {
        // turn tabClicked on just to indicate that focus needs to be displayed
        this.focusedViaKeyboard = true;
        setTimeout(function () {
          return _this2.focusedViaKeyboard = false;
        });
      }
    }
  }, {
    key: "resetClassNames",
    value: function resetClassNames() {
      this.classNames = [];
    }
  }, {
    key: "addBaseClass",
    value: function addBaseClass() {
      if (this.constructor.BASE_CLASS) {
        this.addClass(this.constructor.BASE_CLASS);
      }
    }
  }, {
    key: "addClass",
    value: function addClass(className) {
      this.classNames.push(className);
    }
  }, {
    key: "baseClass",
    value: function baseClass(suffix) {
      return this.constructor.BASE_CLASS + suffix;
    }
  }, {
    key: "applyModifiers",
    value: function applyModifiers() {
      var _this3 = this;

      var modifiers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.resetClassNames();
      this.addBaseClass();
      modifiers.map(function (modifier) {
        return "".concat(_this3.constructor.BASE_CLASS, "--").concat(_this3.props[modifier]);
      }).forEach(function (className) {
        _this3.addClass(className);
      });
    }
  }, {
    key: "getClassNames",
    value: function getClassNames() {
      var commonClasses = [];
      this.props.forcehover && commonClasses.push("lth-is-hover");
      this.props.forcefocus && commonClasses.push("lth-is-focus");
      this.props.forceactive && commonClasses.push("lth-is-active");
      this.props.fullwidth && commonClasses.push("lth-is-fullwidth");
      this.props.disabled && commonClasses.push("lth-is-disabled");
      this.props.pressed && commonClasses.push("lth-is-pressed");
      this.props.loading && commonClasses.push("lth-is-loading"); // disabled component can not have error [Efrat]

      this.props.error && !this.props.disabled && commonClasses.push("lth-has-error");
      var classes = [].concat(_toConsumableArray(this.classNames), commonClasses);
      this.props.className && classes.push(this.props.className);
      return classes.join(" ");
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var style = _objectSpread({}, this.props.style);

      if (this.props.show === false) {
        style.display = "none";
      } // if (this.props['grid-start']) {
      // 	style.gridColumnStart = this.props['grid-start'];
      // }
      // if (this.props['grid-end']) {
      // 	style.gridColumnEnd = this.props['grid-end'];
      // }


      return style;
    }
  }]);

  return Component;
}(_react.default.Component);

exports.default = Component;